export const translationsEn = {
  _confirm: 'Confirm',
  _save: 'Save',
  _cancel: 'Cancel',
  _logout: 'Logout',
  _login: 'Login',
  _yes: 'Yes',
  home_create_shop: 'Don\'t have website. Please create new shop.',
  home_login_existing_shop: 'Auto-login with existing shop',
  home_login_existing_website: 'Please login to connect with existing website.',
  edit_current_category: 'Product Category',
  edit_auto_message: 'Auto-reply meesage for the order',
  edit_manage_shop: 'Manage Shop',
  edit_go_to_shop: 'Go to Shop',
  edit_username: 'Username',
  edit_password: 'Password',
  modal_select_domain: 'Choose you website',
  modal_confirm_create_shop: 'Do you want to create shop?',
  modal_title_confirm_create_shop: 'Create Shop',
  modal_confirm_logout: 'Do you want to logout?',
  modal_title_select_category: 'Select Category',
  can_not_login: 'Can not login'
}
